/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { $el, createElem, getBooleanTypeAttr, getNumTypeAttr, getStrTypeAttr, removeAttrs, setCss, setHtml } from '../../dom-utils';
import { moreThanOneNode, warn } from '../../mixins';
import { randomStr, type } from '../../utils';
import PREFIX from '../prefix';
var Circle = /** @class */ (function () {
    function Circle() {
        this.VERSION = 'v1.0';
        this.COMPONENTS = $el('r-circle', { all: true });
        this._create(this.COMPONENTS);
    }
    Circle.prototype.config = function (el) {
        var target = $el(el);
        var InnerCircle = target.querySelectorAll('path')[1];
        var _a = Circle.prototype, _attrs = _a._attrs, _setPercent = _a._setPercent, _setStrokeColor = _a._setStrokeColor;
        var _b = _attrs(target), percent = _b.percent, strokeWidth = _b.strokeWidth, dashboard = _b.dashboard, strokeColor = _b.strokeColor;
        return {
            get percent() {
                return percent;
            },
            set percent(newVal) {
                if (newVal && !type.isNum(newVal))
                    return;
                _setPercent(InnerCircle, newVal, strokeWidth, dashboard);
            },
            get strokeColor() {
                return strokeColor;
            },
            set strokeColor(newVal) {
                if (newVal && !type.isStr(newVal) && !type.isArr(newVal))
                    return;
                _setStrokeColor(InnerCircle, newVal);
            }
        };
    };
    Circle.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            if (moreThanOneNode(node))
                return;
            var CircleContent = node.firstElementChild;
            var _a = _this._attrs(node), size = _a.size, percent = _a.percent, strokeLinecap = _a.strokeLinecap, strokeWidth = _a.strokeWidth, strokeColor = _a.strokeColor, trailColor = _a.trailColor, trailWidth = _a.trailWidth, dashboard = _a.dashboard;
            _this._setSize(node, size);
            _this._setMainTemplate(node, percent, trailColor, trailWidth, strokeLinecap, strokeWidth, strokeColor, dashboard);
            var InnerCircle = node.querySelectorAll('path')[1];
            _this._setPercent(InnerCircle, percent, strokeWidth, dashboard);
            _this._setStrokeColor(InnerCircle, strokeColor);
            _this._setInnerContent(node, CircleContent);
            removeAttrs(node, [
                'percent',
                'size',
                'stroke-linecap',
                'stroke-width',
                'stroke-color',
                'trail-width',
                'trail-color',
                'dashboard'
            ]);
        });
    };
    Circle.prototype._setSize = function (node, size) {
        setCss(node, 'width', size + "px");
        setCss(node, 'height', size + "px");
    };
    Circle.prototype._setMainTemplate = function (node, percent, trailColor, trailWidth, strokeLinecap, strokeWidth, strokeColor, dashboard) {
        var pathString = this._getPathString(strokeWidth, dashboard);
        var _a = this._getStyle(strokeWidth, dashboard), trailStyle = _a.trailStyle, pathStyle = _a.pathStyle;
        var computedStrokeWidth = percent === 0 && dashboard ? 0 : strokeWidth;
        var template = "\n        <svg viewBox=\"0 0 100 100\">\n          <path\n            d=\"" + pathString + "\"\n            stroke=\"" + trailColor + "\"\n            stroke-width=\"" + trailWidth + "\"\n            fill-opacity=\"0\"\n            stroke-linecap=\"" + strokeLinecap + "\"\n            style=\"" + trailStyle + "\"\n          ></path>\n          <path\n            d=\"" + pathString + "\"\n            stroke-linecap=\"" + strokeLinecap + "\"\n            stroke-width=\"" + computedStrokeWidth + "\"\n            fill-opacity=\"0\"\n            style=\"" + pathStyle + "\"\n          ></path>\n        </svg>\n        ";
        setHtml(node, template);
    };
    Circle.prototype._radius = function (strokeWidth) {
        return 50 - strokeWidth / 2;
    };
    Circle.prototype._setPercent = function (innerCircle, percent, strokeWidth, dashboard) {
        var _radius = Circle.prototype._radius;
        var len = Math.floor(Math.PI * 2 * _radius(strokeWidth));
        if (dashboard) {
            setCss(innerCircle, 'strokeDasharray', (percent / 100) * (len - 75) + "px " + len + "px");
        }
        else {
            setCss(innerCircle, 'strokeDashoffset', ((100 - percent) / 100) * len + "px");
        }
    };
    Circle.prototype._setStrokeColor = function (innerCircle, color) {
        var id = PREFIX.circle + "-" + randomStr(3);
        var addDefs = function (color) {
            if (color.length > 2) {
                warn('👇 The stroke-color attribute of circle cannot pass an array of length greater than 2');
                console.error(innerCircle.parentElement.parentElement);
                return;
            }
            strokeValue = "url(#" + id + ")";
            var defs = Circle.prototype.showDefs(id, color);
            innerCircle.parentElement.insertAdjacentHTML('beforeend', defs);
        };
        var strokeValue;
        if (typeof color === 'string') {
            if (color.startsWith('[') && color.endsWith(']')) {
                addDefs(JSON.parse(color));
            }
            else {
                strokeValue = color;
            }
        }
        else if (Array.isArray(color)) {
            addDefs(color);
        }
        innerCircle.setAttribute('stroke', strokeValue);
    };
    Circle.prototype._getPathString = function (strokeWidth, dashboard) {
        var radius = this._radius(strokeWidth);
        if (dashboard) {
            return "M 50,50 m 0," + radius + "\n          a " + radius + "," + radius + " 0 1 1 0,-" + 2 * radius + "\n          a " + radius + "," + radius + " 0 1 1 0," + 2 * radius;
        }
        else {
            return "M 50,50 m 0,-" + radius + "\n          a " + radius + "," + radius + " 0 1 1 0," + 2 * radius + "\n          a " + radius + "," + radius + " 0 1 1 0,-" + 2 * radius;
        }
    };
    Circle.prototype._getStyle = function (strokeWidth, dashboard) {
        var len = Math.floor(Math.PI * 2 * this._radius(strokeWidth));
        var trailStyle, pathStyle;
        if (dashboard) {
            trailStyle = "\n            stroke-dasharray: " + (len - 75) + "px " + len + "px;\n            stroke-dashoffset: -" + 75 / 2 + "px;\n            transition: stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s\n            ";
            pathStyle = "\n            stroke-dashoffset: -" + 75 / 2 + "px;\n            transition:stroke-dashoffset .3s ease 0s, stroke-dasharray .6s ease 0s, stroke .6s, stroke-width .06s ease .6s\n            ";
        }
        else {
            trailStyle = '';
            pathStyle = "\n              stroke-dasharray: " + len + "px " + len + "px;\n              transition: stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease\n              ";
        }
        return { trailStyle: trailStyle, pathStyle: pathStyle };
    };
    Circle.prototype.showDefs = function (id, color) {
        return "<defs>\n                 <linearGradient id=\"" + id + "\" x1=\"100%\" y1=\"0%\" x2=\"0%\" y2=\"0%\">\n                     <stop offset=\"0%\" stop-color=\"" + color[0] + "\"></stop>\n                     <stop offset=\"100%\" stop-color=\"" + color[1] + "\"></stop>\n                 </linearGradient>\n              </defs>\n              ";
    };
    Circle.prototype._setInnerContent = function (node, content) {
        if (!content)
            return;
        var CircleInner = createElem('div');
        CircleInner.className = PREFIX.circle + "-inner";
        CircleInner.appendChild(content);
        node.appendChild(CircleInner);
    };
    Circle.prototype._attrs = function (node) {
        return {
            size: getNumTypeAttr(node, 'size', 120),
            percent: getNumTypeAttr(node, 'percent', 0),
            strokeWidth: getNumTypeAttr(node, 'stroke-width', 6),
            trailWidth: getNumTypeAttr(node, 'trail-width', 5),
            trailColor: getStrTypeAttr(node, 'trail-color', '#eaeef2'),
            strokeColor: getStrTypeAttr(node, 'stroke-color', '#1890ff'),
            strokeLinecap: getStrTypeAttr(node, 'stroke-linecap', 'round'),
            dashboard: getBooleanTypeAttr(node, 'dashboard')
        };
    };
    return Circle;
}());
export default Circle;
